import { globalGetService } from '@/utils/globalApiServices';
import {
  AuthenticatedUserSuggestion,
  AuthenticatedUserSuggestionParams,
  EventHistoryParams,
  EventHistory,
  RemoteList,
} from './types';

export const getEventHistories = async (params: EventHistoryParams) => {
  const response = await globalGetService<RemoteList<EventHistory>>(
    'dca/event',
    {
      sortField: 'createDate',
      ascendingOrder: false,
      ...params,
    }
  );

  return response?.ok ? response.data : undefined;
};

export const getAuthenticatedUserSuggestions = async (
  params: AuthenticatedUserSuggestionParams
) => {
  const response = await globalGetService(
    'dca/event/suggestion/authenticatedUser',
    params
  );
  return (response?.ok ? response.data : []) as AuthenticatedUserSuggestion[];
};
